import React from 'react';
import { useNavigate } from 'react-router-dom';

const ExecutiveAnchor = ({ prediction, patientId }) => {
  const navigate = useNavigate();
  
  if (!prediction) return null;

  const severityColors = {
    LOW: 'bg-green-100 text-green-700 border-green-200',
    MODERATE: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    HIGH: 'bg-orange-100 text-orange-700 border-orange-200',
    CRITICAL: 'bg-red-100 text-red-700 border-red-200'
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3">
            <span className="text-2xl">🩺</span>
            <span className="text-xs font-medium text-slate-500 uppercase tracking-wider">
              AI Primary Verdict
            </span>
            {patientId && (
              <button
                onClick={() => navigate('/patients')}
                className="text-xs text-indigo-600 hover:text-indigo-800 font-medium hover:underline ml-2"
              >
                Patient: {patientId} ←
              </button>
            )}
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">
            {prediction.label}
          </h2>
          <div className="flex items-center gap-4 mt-2">
            <div className="flex items-center gap-2">
              <span className="text-sm text-slate-500">Confidence:</span>
              <span className="text-lg font-semibold text-indigo-600">
                {(prediction.confidence * 100).toFixed(0)}%
              </span>
            </div>
            <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${severityColors[prediction.severity] || severityColors.MODERATE}`}>
              {prediction.severity}
            </span>
          </div>
        </div>
        
        {/* Right Panel - Navigation Actions */}
        <div className="flex flex-col gap-2 items-end">
          <button 
            type="button"
            onClick={() => navigate('/patients')} 
            className="text-sm text-indigo-600 hover:text-indigo-800 font-medium text-left hover:underline"
          >
            ← Back to Patient List
          </button>
          <button 
            type="button"
            onClick={() => navigate('/capture')} 
            className="text-xs text-slate-500 hover:text-slate-700 text-left hover:underline"
          >
            🎙️ Capture New Modality Data
          </button>
          <button 
            type="button"
            onClick={() => navigate('/analytics')} 
            className="text-xs text-slate-400 hover:text-slate-600 text-left hover:underline"
          >
            📈 View Fleet-Wide Metrics
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveAnchor;
